

// import moment from 'moment'
import moment from 'moment-hijri'
import Vue from "vue"
import {defaultLocale} from "@/app/config";

moment.updateLocale('ar-no-al', {
    weekdays: [
        "الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"
    ],
    weekdaysShort: [
        "الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"
    ],
    weekdaysMin: [
        "الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"
    ]
});
Vue.prototype.$moment = moment
moment.locale(defaultLocale)

export default moment
